import {createStructuredSelector} from "reselect"
import {
  selectIsSettlementSelectionPrior,
  selectSettlementNewSelectionCompany,
} from "manager/selectors/referral_status_selectors"
import {
  fetchSearchConfig,
  fetchTitleMatches,
  setEditTitleCompany,
  setNewTitleCompany,
  useNewSettlementSelection
} from "manager/redux/referral_status"
import {connect} from "react-redux"
import React, {Component} from "react"
import {scrollToTop} from "manager/util/helper"
import styled from "styled-components"
import clearSvg from "../../../../../images/clear-x.svg"
import {
  selectAssignmentTransactionHash,
  selectSelectedSettlementProviderName
} from "manager/selectors/referral_selectors"
import {
  selectSearchConfig,
  selectSearchResults,
  selectSearchResultsPending
} from "manager/selectors/settlement_provider_search_selectors"

const TITLE_SEARCH_LIMIT = 3

const TitleProviderDetailsContainer = styled.div`
  margin-top: 8px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;
`

const TitleProviderTypeahead = styled.input`
  margin: 0 4px;
  padding: 10px 8px;
  outline: none;
  width: 100%;
  border: none;
`

const ClearIcon = styled.div`
  background-image: url(${clearSvg});
  background-size: cover;
  width: 16px;
  height: 17px;
  flex: 0 0 16px;
  cursor: pointer;
  margin-right: 15px;
`

const Label = styled.label`
  font-size: 11px;
  font-weight: normal;
  margin: 12px 0px 2px 0px;
  display: inline-block;
  color: #545454;
`

const AutoCompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  background: white;
`

const AutoCompleteRow = styled.div`
  cursor: pointer;
  font-size: 14px;
  color: #4A4A4A;
  padding: 12px 16px;
  :hover {
    background-color: #EEF5FF;
    font-weight: 600;
  }
  
  .city {
    font-size: 12px;
    color: #8C8C8C;
  }
`

class TitleProviderAutocomplete extends Component {
  state = {
    showAutoComplete: false,
    skipBlur: false,
    suggestionsOn: false
  }

  componentDidMount() {
    const {fetchSearchConfig, hash, getOriginAddrOverride} = this.props
    if (hash) {
      fetchSearchConfig(hash, getOriginAddrOverride ? getOriginAddrOverride() : null)
    }
  }

  handleChange = (e) => {
    const { fetchTitleMatches, setEditTitleCompany, setNewTitleCompany, useNewSettlementSelection, onTitleProviderChange } = this.props
    const searchValue = e.target.value
    const typeaheadOn = searchValue.length > 0
    this.setState((state) => {
      return state.skipBlur ?
        {skipBlur: false, showAutoComplete: typeaheadOn, suggestionsOn: !typeaheadOn} : {showAutoComplete: typeaheadOn, suggestionsOn: !typeaheadOn}
    })
    useNewSettlementSelection()
    setEditTitleCompany(false)
    setNewTitleCompany({name: searchValue})
    fetchTitleMatches({payload: {searchValue}})

    if(onTitleProviderChange){
      onTitleProviderChange({'name': searchValue})
    }
  }

  hideAutoComplete = () => {
    this.setState({showAutoComplete: false})
  }

  handleClick = (titleCompany) => {
    const { setNewTitleCompany, useNewSettlementSelection, onTitleProviderChange } = this.props
    useNewSettlementSelection()
    setNewTitleCompany(titleCompany)
    this.hideAutoComplete()

    if(onTitleProviderChange){
      onTitleProviderChange(titleCompany)
    }
  }

  handleFocus = () => {
    scrollToTop()
    this.setState({showAutoComplete: true, suggestionsOn: true})
  }

  handleClear = () => {
    const {setNewTitleCompany, useNewSettlementSelection, onTitleProviderChange} = this.props
    useNewSettlementSelection()
    setNewTitleCompany(null)

    if(onTitleProviderChange){
      onTitleProviderChange(null)
    }
  }

  setSkipBlur = (shouldSkip) => {
    this.setState({skipBlur: shouldSkip})
  }

  render() {
    const { isSettlementSelectionPrior, newSelectionCompany, searchConfig, searchResults, searchResultsPending, selectedSettlementProviderName, isRequired } = this.props
    const haveSuggestions = searchConfig && searchConfig.default_suggestions && searchConfig.default_suggestions.length > 0
    const results = this.state.suggestionsOn && haveSuggestions ? searchConfig.default_suggestions : searchResults
    const label = isRequired === false ? "Title Provider Name" : "Title Provider Name*"

    return (
      <div>
        <Label>{label}</Label>
        <TitleProviderDetailsContainer>
          <TitleProviderTypeahead
            value={isSettlementSelectionPrior ? selectedSettlementProviderName : newSelectionCompany && newSelectionCompany.name}
            placeholder="Provider name"
            autoComplete="new-settlement-provider-search"
            onChange={e => this.handleChange(e)}
            onBlur={() => !this.state.skipBlur ? this.hideAutoComplete() : null }
            onFocus={this.handleFocus}
          />
          {(isSettlementSelectionPrior || (newSelectionCompany && newSelectionCompany.name && newSelectionCompany.name.length > 0)) && <ClearIcon onClick={() => this.handleClear()} />}
        </TitleProviderDetailsContainer>
        { this.state.showAutoComplete && <AutoCompleteContainer>
          { searchResultsPending && <AutoCompleteRow>loading...</AutoCompleteRow> }
          { results && results.length>0 && results.slice(0, TITLE_SEARCH_LIMIT).map(agency =>
            <AutoCompleteRow
              key={agency.id}
              onMouseDown={() => this.setSkipBlur(true)}
              onClick={() => this.handleClick(agency)}>
              <div>{agency.name}</div>
              { (agency.city && agency.state) && (
                <div className='city'>
                  <span>{agency.city}, {agency.state}</span>
                  {agency.distance_from_addr && (
                    <span>
                      &nbsp;&#183;&nbsp;
                      {agency.distance_from_addr.toFixed(agency.distance_from_addr < 10 ? 1 : 0) + ' mi'}
                    </span>
                  )}
                </div>
              )}
            </AutoCompleteRow>)}
        </AutoCompleteContainer> }
      </div>
    )
  }

}

const selector = createStructuredSelector({
  newSelectionCompany: selectSettlementNewSelectionCompany,
  hash: selectAssignmentTransactionHash,
  searchConfig: selectSearchConfig,
  searchResults: selectSearchResults,
  searchResultsPending: selectSearchResultsPending,
  isSettlementSelectionPrior: selectIsSettlementSelectionPrior,
  selectedSettlementProviderName: selectSelectedSettlementProviderName,
})

const actions = {
  setNewTitleCompany,
  setEditTitleCompany,
  useNewSettlementSelection,
  fetchTitleMatches,
  fetchSearchConfig,
}

export default connect(selector, actions)(TitleProviderAutocomplete)
